import React from 'react';
import { combineClassNames, formatPriceWithCurrencySymbol } from '../../../../../../app/functions';
import './index.scss';

const PaymentDetailsRow = ({
    label,
    subtitle,
    value,
    erasedValue = null,
    error = null,
    boldLabel = false,
    isCentered = false,
    boldValue = true,
}) => {
  const isTextualValue = ['string', 'number'].includes(typeof value);

  return (
    <>
      <div className={combineClassNames('payment-details-row', isCentered && 'payment-details-row_centered')}>
        <div className={combineClassNames('payment-details-label', boldLabel && 'payment-details-label_bold')}>
          {label}
          {subtitle && (
            <>
              <br/>
              <span className={combineClassNames('payment-details-sub-title')}>{subtitle}</span>
            </>
          )}
        </div>

        {isTextualValue && (
          <div>
            {erasedValue && (
              <div className="payment-details-value payment-details-value_erased">
                {formatPriceWithCurrencySymbol(erasedValue)}
              </div>
            )}
            {' '}
            <div className={combineClassNames('payment-details-value', boldValue && 'payment-details-value_bold')}>{formatPriceWithCurrencySymbol(value)}</div>
          </div>
        )}

        {!isTextualValue && value}
      </div>

      {error && (
        <div className="payment-details-error">{error}</div>
      )}
    </>
  );
};

export default PaymentDetailsRow;
